import { HistoryResponse } from 'app/model/history-response';
import { SeamRequest } from 'app/model/seam-request';

import { RestfulApiService } from '../restful-api.service';

export class SeamRequestHistoryService extends RestfulApiService<HistoryResponse, SeamRequest> {
    protected getFormName(): string {
        throw new Error('Method not implemented.');
    }
    protected getPath(parent: SeamRequest): string {
        return `seam-workflows/${parent.id}/history`;
    }
}
export const seamRequestHistoryService = new SeamRequestHistoryService();
